// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gnmS","content":"styles_content__1flFO","tableWrap":"styles_tableWrap__1ECPL"};